import * as reminderActions from "src/redux/slices/reminder";
import { toast } from "sonner";

export const saveReminder = (
  payload: any,
  dispatch: any,
  onSuccess?: () => void
) => {
  new Promise((resolve, reject) => {
    dispatch(
      reminderActions.createReminderRequest({
        payload,
        resolve,
        reject,
      })
    );
  })
    .then((res) => {
      toast.success("Reminder saved successfully");
      // Call the success callback to refetch reminders
      if (onSuccess) {
        onSuccess();
      }
    })
    .catch((err) => {
      console.error("err => ", err);
      toast.error("Failed to save reminder");
    });
};

export const updateReminder = (
  payload: any,
  dispatch: any,
  onSuccess?: () => void
) => {
  new Promise((resolve, reject) => {
    dispatch(
      reminderActions.updateReminderRequest({
        payload,
        resolve,
        reject,
      })
    );
  })
    .then((res) => {
      toast.success("Reminder updated successfully");
      // Call the success callback to refetch reminders
      if (onSuccess) {
        onSuccess();
      }
    })
    .catch((err) => {
      console.error("err => ", err);
      toast.error("Failed to update reminder");
    });
};
